<template>
  <CFooter :fixed="false">
    <div>
      <a href="https://zoodkomak.com" target="_blank">پنل فروشنده  </a>
      <span class="ml-1"></span>
    </div>
    <div class="ml-auto">
      <span class="mr-1"> تمامی حقوق متعلق به زودکمک میباشد</span>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
